import { styled } from '@mui/material';
import Dialog from '@mui/material/Dialog';

export const StyledResourceDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: '0.5rem',
  },
}));
